import { render, staticRenderFns } from "./aidaStudentReg.vue?vue&type=template&id=641b1b70&scoped=true&"
import script from "./aidaStudentReg.vue?vue&type=script&lang=js&"
export * from "./aidaStudentReg.vue?vue&type=script&lang=js&"
import style0 from "./aidaStudentReg.vue?vue&type=style&index=0&id=641b1b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b1b70",
  null
  
)

export default component.exports